import { EntityDrawerProps, FCC, FormDrawer, FormDrawerContent, TextField, isEmail } from "@dgs/core";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { IContactEmailFormState } from "../../shared/types";
import { EmailTypeSelectField } from "../selects/EmailTypeSelectField";

interface ContactEmailDrawerProps extends EntityDrawerProps<IContactEmailFormState> {
	hasUser: boolean;
}

export const ContactEmailDrawer: FCC<ContactEmailDrawerProps> = ({ hasUser, children, ...props }) => {
	const { t } = useTranslation();

	const validate = useCallback(
		(values: IContactEmailFormState) => {
			const errors: { [K in keyof IContactEmailFormState]?: any } = {};

			if (!values.email) {
				errors.email = t("Required field");
			} else if (!isEmail(values.email)) {
				errors.email = t("Invalid email address");
			}

			return errors;
		},
		[t],
	);

	return (
		<FormDrawer
			{...props}
			validate={validate}
			renderForm={(formProps) => (
				<FormDrawerContent {...formProps}>
					<TextField name="email" label={t("Email")} disabled={props.initialValues.isPrimary && hasUser} required />
					<EmailTypeSelectField name="type" label={t("Type")} disabled={props.initialValues.isPrimary && hasUser} />
					{children}
				</FormDrawerContent>
			)}
		/>
	);
};
